var render = function render(){var _vm=this,_c=_vm._self._c;return _c('projects-list-view-template',{attrs:{"namespace":_vm.namespace,"can-create-project":_vm.canCreateProject},scopedSlots:_vm._u([{key:"projects",fn:function({ onlyPublic }){return [_c('projects-table-data-loader',{key:_vm.namespace + _vm.$route.name,attrs:{"show-namespace":false,"namespace":_vm.namespace,"only-public":onlyPublic}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }